/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { EyeOpenIcon16Light } from './EyeOpenIcon16Light';
import { EyeOpenIcon16Regular } from './EyeOpenIcon16Regular';
import { EyeOpenIcon16Solid } from './EyeOpenIcon16Solid';
import { EyeOpenIcon20Light } from './EyeOpenIcon20Light';
import { EyeOpenIcon20Regular } from './EyeOpenIcon20Regular';
import { EyeOpenIcon20Solid } from './EyeOpenIcon20Solid';
import { EyeOpenIcon24Regular } from './EyeOpenIcon24Regular';
import { EyeOpenIcon24Solid } from './EyeOpenIcon24Solid';
import { EyeOpenIcon32Regular } from './EyeOpenIcon32Regular';
import { EyeOpenIcon64Regular } from './EyeOpenIcon64Regular';
var sizes = {
    16: {
        light: EyeOpenIcon16Light,
        regular: EyeOpenIcon16Regular,
        solid: EyeOpenIcon16Solid,
    },
    20: {
        light: EyeOpenIcon20Light,
        regular: EyeOpenIcon20Regular,
        solid: EyeOpenIcon20Solid,
    },
    24: {
        regular: EyeOpenIcon24Regular,
        solid: EyeOpenIcon24Solid,
    },
    32: {
        regular: EyeOpenIcon32Regular,
    },
    64: {
        regular: EyeOpenIcon64Regular,
    },
};
export var EyeOpenIcon = forwardRef('EyeOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
